import { CloudForwarderForwarders } from "@graylog/enterprise-api";
const fetchForwarderNode = (nodeId) => CloudForwarderForwarders.getByNodeId(encodeURIComponent(nodeId)).then((response) => response == null ? void 0 : response.forwarder);
export default fetchForwarderNode;
